/**
 * Convert display-track messages to LLM prompt format from a specific bot's perspective.
 *
 * @param {Array} messages - Messages from the display track (role: 'user' | 'participant')
 * @param {string} selfId - This bot's participant ID ('__myagent__' or worker public key)
 * @param {Object} nameMap - Map of participantId → displayName
 * @param {Object} options
 * @param {number} options.maxMessages - Max messages to include (default 20)
 * @returns {Array<{role: 'user'|'assistant', content: string}>}
 */
export function conversationToPrompt(messages, selfId, nameMap = {}, options = {}) {
  const { maxMessages = 20 } = options
  const recent = messages.length > maxMessages
    ? messages.slice(-maxMessages)
    : messages

  const result = []
  for (const msg of recent) {
    if (!msg.content) continue
    // Skip tool calls, role requests, pending indicators
    const type = msg.metadata?.type
    if (type === 'tool_call' || type === 'role_request' || type === 'chat_pending') continue

    if (msg.role === 'user') {
      result.push({ role: 'user', content: msg.content })
    } else if (msg.role === 'participant') {
      if (msg.participantId === selfId) {
        result.push({ role: 'assistant', content: msg.content })
      } else {
        const name = nameMap[msg.participantId] || msg.metadata?.displayName || 'Bot'
        result.push({ role: 'user', content: `[${name}]: ${msg.content}` })
      }
    }
  }
  return result
}
